module.exports = __webpack_public_path__ + "img/icon-alert_triangle.ed5bd4b3.svg";